export default {"src":"/_next/static/media/risk-treatment-plan.1bccc5b3.svg","height":452,"width":452,"blurWidth":0,"blurHeight":0};